import { EventEmitter as EventEmitter3 } from 'eventemitter3';
export function createEventEmmiter() {
    return new EventEmitter3();
}
//# sourceMappingURL=event_emitter.js.map